export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Planifiqué mi año escolar completo en una tarde. Ahora cada clase tiene un objetivo claro y mis estudiantes me piden que no termine. Cambió todo.',
    author: 'Mariana T.',
    role: 'Docente de Educación Física',
    location: 'México',
  },
  {
    quote:
      'Mis estudiantes mejoraron en dos meses más que en todo el año anterior. La progresión tiene sentido pedagógico real: no es solo “jugar”.',
    author: 'Carlos M.',
    role: 'Profesor de Educación Física',
    location: 'Colombia',
  },
  {
    quote:
      'Dejé de buscar actividades en internet. Abro el MEGAPACK y está todo: sesiones, evaluaciones, rúbricas y juegos. Libertad real.',
    author: 'Sofía L.',
    role: 'Coordinadora de área',
    location: 'España',
  },
  {
    quote:
      'Enseño en una escuela pública sin presupuesto y este kit es oro. Cero material y máxima calidad pedagógica.',
    author: 'Roberto G.',
    role: 'Docente de Primaria',
    location: 'Perú',
  },
  {
    quote:
      'Las rúbricas me salvaron. Hablo con las familias en competencias desarrolladas y datos reales, no en conversaciones vagas sobre conducta.',
    author: 'Andrea P.',
    role: 'Coordinadora pedagógica',
    location: 'Chile',
  },
  {
    quote:
      'Como docente nuevo, esto me dio un sistema profesional desde el primer día. Mi confianza en clase se multiplicó y los estudiantes lo notan.',
    author: 'Juan P.',
    role: 'Profesor recién graduado',
    location: 'Argentina',
  },
]
